// extracted by mini-css-extract-plugin
export const header = "Header-module--header--1Qt4T";
export const title = "Header-module--title--2NCtK";